"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateNpi = void 0;
function validateNpi(npi) {
    if (typeof npi !== 'string')
        return false;
    return Boolean(npi.match('^\\d{10}$'));
}
exports.validateNpi = validateNpi;
//# sourceMappingURL=validateNpi.js.map